import { TextStyleFontWeight } from "pixi.js";

export default class RhFontsUtil {
    public static rhd_v9_icons: string = "rhdicons";
}

type Font = {
    id: string;
    weight?: TextStyleFontWeight;
    name?: TextStyleFontWeight;
    src: string;
};

// Define the list of available fonts.
const fontList: Font[] = [
    { id: "panton", src: "web-fonts/pantonregular/font.woff2" } as Font,
    { id: "panton", weight: "400", name: "normal", src: "web-fonts/pantonregular/font.woff2" } as Font,
    { id: "panton", weight: "700", name: "bold", src: "web-fonts/pantonbold/font.woff2" } as Font,
    { id: "panton", weight: "900", name: "bolder", src: "fonts/panton/panton-heavy.ttf" } as Font,
    { id: "marvinround", src: "fonts/marvin-round.ttf" } as Font,
    { id: "rhdicons", src: `fonts/rhdicons.ttf` } as Font,
    { id: "quicksandbld", src: "fonts/quicksandbld.ttf" } as Font,
    { id: "sweaterschoolreg", src: "fonts/sweaterschoolreg.ttf" } as Font,
    { id: "cardedureg", src: "fonts/cardedureg.ttf", } as Font,
    { id: "fontawesome6proreg", src: "fonts/fontawesome6proreg.otf", } as Font,
    { id: "fontawesome6prosolid", src: "fonts/fontawesome6prosolid.otf", } as Font,
    // Add more fonts here...
];

/**
 * Validates the font weight for a given font family.
 * @param fontFamily - The font family to validate.
 * @param fontWeight - The font weight to validate.
 * @returns A boolean indicating whether the font weight is valid for the font family.
 * @throws An error if the font weight is invalid for the font family.
 */
export const validateFontWeight = (fontFamily: string, fontWeight: string) => {
    const fontMatches = fontList.filter((font) => font.id === fontFamily);
    if (fontMatches.length === 0) throw new Error(`Invalid font family ${fontFamily}`);
    // search for font with weight
    const font = fontMatches.find((font) => font.weight === fontWeight || font.name === fontWeight);
    if (!font) {
        const validWeightsAndNames = fontMatches
            .flatMap((font) => [font.weight ? `${font.weight}` : null, font.name ? `${font.name}` : null])
            .filter(Boolean)
            .join(", ");
        throw new Error(`Invalid font weight ${fontWeight} for font family ${fontFamily}. Valid font weights are: ${validWeightsAndNames}`);
    }
};

/**
 * Bundle the fonts to be loaded.
 */
export const FontsBundle = fontList.reduce((fonts, font) => {
    const fontFamily = font.name ? `${font.id}${font.name}` : font.id;
    // create font object without weights
    if (!fonts[fontFamily] && !font.weight && !font.name) fonts[fontFamily] = { src: font.src, data: { family: font.id } };
    if (font.weight) {
        const fontFamilyWithWeight = `${font.id}${font.weight}`;
        fonts[fontFamilyWithWeight] = { src: font.src, data: { family: font.id, weights: [font.weight] } };
    }
    if (font.name) {
        const fontFamilyWithName = `${font.id}${font.name}`;
        fonts[fontFamilyWithName] = { src: font.src, data: { family: font.id, weights: [font.name] } };
    }
    return fonts;
}, {});
